export default __webpack_public_path__ + "static/media/data.9dd1d91d.svg";